import { PURCHASE_SOURCE_NAME_MAP } from '@models/statistics';
import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';

interface Props {
  data: { date: string; actionId: string; count: number }[];
}

const DailyPurchaseSourceChart: React.FC<Props> = ({ data }) => {
  const chartData = useMemo(() => {
    const dates = [...Array.from(new Set(data.map((item) => item.date)))].sort();
    const actionIds = [...Array.from(new Set(data.map((item) => item.actionId)))];

    const datasets = actionIds
      .map((actionId) => {
        const counts = dates.map((date) => {
          const item = data.find((d) => d.date === date && d.actionId === actionId);
          return item ? item.count : 0;
        });

        return {
          label: PURCHASE_SOURCE_NAME_MAP[actionId as keyof typeof PURCHASE_SOURCE_NAME_MAP] || actionId,
          data: counts,
          fill: false,
          borderWidth: 2,
        };
      })
      .sort((a, b) => b.data[0] - a.data[0]);

    return {
      labels: dates,
      datasets,
    };
  }, [data]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default DailyPurchaseSourceChart;
